import { NgModule } from '@angular/core';
import { SubscribePage } from 'pages/subscribe/subscribe';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [SubscribePage],
    imports: [PagesModule, ComponentsModule]
})
export class SubscribePageModule {}
